import { render } from "./GeneralDisclaimer.vue?vue&type=template&id=be9bc74c&scoped=true"
const script = {}

import "./GeneralDisclaimer.vue?vue&type=style&index=0&id=be9bc74c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9bc74c"]])

export default __exports__